import apiClient from './apiClient';

export interface TestType {
  TestKey: string;
  TestName: string;
}

export const getTests = async (): Promise<TestType[]> => {
  const response = await apiClient.get<TestType[]>('/tests');
  return response.data;
};
